<template>
    <path :style="{ fill: color }" d="M96.3,90.9c-0.9-1-1.8-2-2.9-2.8c-5-4-11.9-6.5-16.9-8.1c-3.7-1.2-6.2-2-6.2-2l-16.5,2.6l-16.5-2.6
	c0,0-2.6,0.8-6.2,2c-5,1.6-11.9,4.1-16.9,8.1c-1.1,0.9-2,1.8-2.9,2.8c8.8,14.2,24.6,23.7,42.5,23.7S87.5,105.1,96.3,90.9z"/>
</template>

<script>
    export default {
        name: 'Cloth1',
        props: {
            color: {
                type: String,
                required: true,
            },
        },
    }
</script>

<style scoped>

</style>
